import React from 'react';
import RootProvider from './utils/root_provider';
import AlbumsComponent from "./containers/albums/index";

/**
 * Based on condition onwed albums or timeline view or SAV or shared tabs will be shown 
 * as we are not having react-routing, but on later part showing of views will be done with react-router-dom
 * @param {config} param
 * @returns 
 */
const LibraryApp = ({config}) => {
    return (
        <RootProvider>
            <AlbumsComponent config={config}></AlbumsComponent>
        </RootProvider>
    )
}

export default LibraryApp;